import { render, staticRenderFns } from "./LegendaCurvaAbcRentabilidade.vue?vue&type=template&id=f8546114&scoped=true"
import script from "./LegendaCurvaAbcRentabilidade.vue?vue&type=script&lang=js"
export * from "./LegendaCurvaAbcRentabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8546114",
  null
  
)

export default component.exports